export const esVentaCuentaCorriente = (documento) => Number(documento?.Signo) === 1;
